
var Model = require("../types/Model.js");
var xtend = require("xtend");

module.exports = Model({
	name: "messagingcontacts",

	init: init,
	uninit: uninit,
	listeners: listeners,

	recalculate: recalculate
});

function init(){
	this._missed = {};
	this._groups = [];
	this._contacts = [];

	this.push({
		contacts: [],
		groups: []
	});
}

function uninit(){
	this._missed = null;
	this._contacts = null;
	this._groups = null;
}

function listeners(){
	return {
		"contacts:updated": Model.makeRecalculator("contacts"),
		"missedmessages:updated": Model.makeRecalculator("missed"),
		"groups:updated": Model.makeRecalculator("groups")
	};
}

function recalculate(){
	var missed = this._missed;
	var contacts = this._contacts;
	var groups = this._groups;

	if(!groups && !contacts && !missed)
		return;

	var seperateContacts = contacts.reduce(function(obj, contact){
		var missedMessages = missed[contact._id];
		var newContact = xtend(contact, {
			missed: missedMessages || 0
		});
		if(missedMessages){
			obj.missed.push(newContact);
		} else {
			obj.list.push(newContact);
		}
		return obj;
	}, {
		list: [], missed: []
	});


	var seperateGroups = groups.reduce(function(obj, group){
		var missedMessages = missed[group._id];
		var newGroup = xtend(group, {
			missed: missedMessages || 0
		});
		if(missedMessages){
			obj.missed.push(newGroup);
		} else {
			obj.list.push(newGroup);
		}
		return obj;
	}, {
		list: [], missed: []
	});

	this.extend({
		contacts: seperateContacts.missed.concat(seperateContacts.list.sort(compare_names)),
		groups: seperateGroups.missed.concat(seperateGroups.list.sort(compare_group_names)),
	});
}

function compare_names(person1, person2) {
	var name1 = (person1.fname || "") + " " + (person1.lname || "");
	var name2 = (person2.fname || "") + " " + (person2.lname || "");

	if (name1 < name2) return -1;
	if (name2 < name1) return 1;
	return 0;
}

function compare_group_names(group1, group2){
	var name1 = (group1.name || "");
	var name2 = (group2.name || "");

	if(name1 < name2) return -1;
	if(name2 < name1) return 1;
	return 0;
}


